import { useOutletContext } from 'react-router-dom';
import { LayoutContext } from '../types/translations';

const About: React.FC = () => {
  const { texts } = useOutletContext<LayoutContext>();
  
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#1a1a1a] text-gray-900 dark:text-white transition-colors duration-200">
      {/* Main Content */}
      <main className="container mx-auto px-6 pt-32">
        <section className="space-y-12">
          {/* --- First paragraph with image on the right --- */}
          <div className="flex flex-col md:flex-row items-center">
            <div className="flex-1 md:pr-8">
              <h2 className="text-3xl font-bold mb-4">{texts.about.firstTitle}</h2>
              <p className="text-lg text-gray-600 dark:text-gray-300">
                {texts.about.firstParagraph}
              </p>
            </div>
            <img src="https://res.cloudinary.com/dlplieq2c/image/upload/v1736630835/AntonExpedia1_mhucah.jpg" alt="About me 1" className="w-full md:w-1/3 h-auto rounded-lg mt-6 md:mt-0" />
          </div>

          {/* --- Second paragraph with image on the left --- */}
          <div className="flex flex-col md:flex-row-reverse items-center">
            <div className="flex-1 md:pl-8">
              <h2 className="text-3xl font-bold mb-4">{texts.about.secondTitle}</h2>
              <p className="text-lg text-gray-600 dark:text-gray-300">
                {texts.about.secondParagraph}
              </p>
            </div>
            <img src="https://res.cloudinary.com/dlplieq2c/image/upload/v1736630835/AntonExpedia1_mhucah.jpg" alt="About me 2" className="w-full md:w-1/3 h-auto rounded-lg mt-6 md:mt-0" />
          </div>

          {/* --- Another standalone paragraph (no image) --- */}
          <div>
            <h2 className="text-3xl font-bold mb-4">{texts.about.thirdTitle}</h2>
            <p className="text-lg text-gray-600 dark:text-gray-300">
              {texts.about.thirdParagraph}
            </p>
          </div>

          {/* --- Final image --- */}
          <div className="text-center">
            <img src="https://res.cloudinary.com/dlplieq2c/image/upload/v1736630835/AntonExpedia1_mhucah.jpg" alt="About me 3" className="inline-block max-w-full md:max-w-2xl rounded-lg mt-6" />
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
